import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/fe-webapp-next/components/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/fe-webapp-next/components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollArea"] */ "/app/fe-webapp-next/components/ui/scroll-area.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.9.1_next@15.5.15_@babel+core@7.29.0_@opentelemetry+api@1.9.1_babel-plugin-r_d4351051f36dadcdea1f20e9d7ce036c/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
